import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-accent-500 uppercase tracking-wider mb-2">WHY CHOOSE US</p>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900">网站特色</h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-lg mx-auto">
            吃瓜网站的核心优势，为您提供最佳的访问体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {featuresData.map((feature, i) => (
            <div key={i} className="text-center p-8 bg-background-100 rounded-2xl border border-background-200/70 hover:border-background-300 transition-colors cursor-pointer">
              <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-accent-100 flex items-center justify-center">
                <i className={`${feature.icon} text-accent-600 text-2xl`}></i>
              </div>
              <h3 className="font-semibold text-foreground-900 mb-3 text-sm">{feature.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}